import React, { useEffect } from 'react';
import { MUIDataTable, TableActionTypes, useDataTable } from 'web-library';
import { WithdrawDetails } from '../../api/candidate/exam/model';

interface ReviewWithdrawalDataTableProps {
  withdrawalDetails: WithdrawDetails;
}

const ReviewWithdrawalDataTable = ({ withdrawalDetails }: ReviewWithdrawalDataTableProps) => {
  const { state, dispatch: tableDispatch } = useDataTable();

  useEffect(() => {
    if (withdrawalDetails) {
      const count = withdrawalDetails.examRegistrationSubjectInfoModels?.length;

      tableDispatch({
        type: 'UPDATE_DATA',
        payload: {
          data: withdrawalDetails.examRegistrationSubjectInfoModels,
          count,
        },
      } as TableActionTypes);
    }
  }, [withdrawalDetails, tableDispatch]);

  const columnOptions = [
    {
      name: 'subjectName',
      label: 'Subject Name',
      options: {
        customBodyRenderLite: (dataIndex: number) => {
          if (dataIndex === undefined) {
            return [];
          }

          return `${state.data[dataIndex].subjectName} (${state.data[dataIndex].subjectCode})`;
        },
      },
    },
    {
      name: 'subjectLevel',
      label: 'Subject Level',
    },
    {
      name: 'examSeries',
      label: 'Exam Series',
    },
    {
      name: 'examLevel',
      label: 'Exam Level',
    },
    {
      name: 'languageMedium',
      label: 'Language Medium',
    },
  ];

  return (
    <MUIDataTable
      columns={columnOptions}
      state={state}
      data={state.data}
      dispatch={tableDispatch}
    />
  );
};
export default ReviewWithdrawalDataTable;
